import { NgModule } from '@angular/core';
import { IconPipe } from './icon.pipe';

@NgModule({
  declarations: [IconPipe],
  exports: [IconPipe]
})
export class IconPipeModule {}
